<template>
    <svg
        id="Layer_2"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 442.07 212.37">
        <defs>
            <clipPath id="clippath">
                <rect
                    x="20.3"
                    y="88.24"
                    width="116.43"
                    height="117.55"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-1">
                <rect
                    x="304.84"
                    y="79.64"
                    width="116.43"
                    height="117.55"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-2">
                <rect
                    x="182.23"
                    y="179.11"
                    width="79.76"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-3">
                <rect
                    x="182.23"
                    y="179.11"
                    width="3.84"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-4">
                <rect
                    x="190.66"
                    y="179.11"
                    width="3.84"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-5">
                <rect
                    x="199.09"
                    y="179.11"
                    width="3.86"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-10">
                <rect
                    x="241.26"
                    y="179.11"
                    width="3.86"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-11">
                <rect
                    x="249.71"
                    y="179.11"
                    width="3.84"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
            <clipPath id="clippath-12">
                <rect
                    x="258.14"
                    y="179.11"
                    width="3.84"
                    height="3.91"
                    fill="none"
                    stroke-width="0" />
            </clipPath>
        </defs>
        <g id="Layer_2-2">
            <rect
                id="Rectangle_329"
                x="285.42"
                y="58.34"
                width="156.07"
                height="21.3"
                fill="#f47941"
                stroke-width="0" />
            <path
                id="Path_2338"
                d="m338.28,63.58c-2.09,0-3.79,1.7-3.79,3.79s2.86,5.06,3.88,6.72c1.01-1.67,3.7-4.59,3.7-6.72s-1.7-3.78-3.79-3.79m0,5.42c-.96,0-1.73-.78-1.73-1.74s.78-1.73,1.74-1.73,1.73.78,1.73,1.74h0c0,.96-.78,1.73-1.74,1.73"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2278"
                d="m138.16,22.97c9.5,0,17.19,7.7,17.2,17.2v152.93c0,9.5-7.7,17.19-17.2,17.2H18.88c-9.5,0-17.19-7.7-17.2-17.2V40.17c0-9.5,7.7-17.19,17.2-17.2h119.28Zm0-1.65H18.88C8.47,21.32.03,29.76.03,40.17v152.94c0,10.41,8.44,18.85,18.85,18.85h119.27c10.41,0,18.85-8.44,18.85-18.85V40.17c0-10.41-8.44-18.85-18.85-18.85"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2279"
                d="m155.6,58.35v-15.4c.56-13.68-8.91-20.46-21.35-21.54H21.35C9.51,21.46-.05,31.1,0,42.95v15.4s155.6,0,155.6,0Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2250"
                d="m423.22,23.38c9.5,0,17.19,7.7,17.2,17.2v152.93c-.01,9.49-7.7,17.19-17.2,17.2h-119.27c-9.49,0-17.19-7.71-17.2-17.2V40.58c0-9.5,7.7-17.19,17.2-17.2h119.27Zm0-1.65h-119.27c-10.41,0-18.85,8.44-18.85,18.85v152.94c0,10.41,8.44,18.85,18.85,18.85h119.27c10.41,0,18.85-8.44,18.85-18.85V40.58c0-10.41-8.44-18.85-18.85-18.85"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2251"
                d="m441.59,59.16v-15.34c.09-13.33-9.52-22.76-21.44-21.46h-113.38c-5.31-.08-10.48,1.7-14.63,5.02-4.56,3.93-6.82,9.95-6.82,16.44v15.34h156.27Z"
                fill="#5c73b8"
                stroke-width="0" />
            <rect
                id="Rectangle_310"
                x="345.23"
                y="2.43"
                width="35.71"
                height="35.71"
                fill="none"
                stroke-width="0" />
            <path
                id="Path_1563"
                d="m75.81,22.72c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                fill="#5c73b8"
                stroke-width="0" />
            <text
                transform="translate(322.11 50.36)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="12"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Linked Program
                </tspan>
            </text>
            <text
                transform="translate(26.78 50.36)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="12"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Publishing Program
                </tspan>
            </text>
            <text
                transform="translate(346.23 72.79)"
                fill="#fafbfb"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    You are here
                </tspan>
            </text>
            <g
                id="Group_296-2"
                opacity=".56">
                <g id="Group_295-2">
                    <g clip-path="url(#clippath)">
                        <g id="Group_294-2">
                            <path
                                id="Path_964-2"
                                d="m133.86,171.91l-59.11,33.17c-2.7,1.51-6.11.55-7.62-2.14L21.01,120.76c-1.51-2.7-.55-6.1,2.14-7.62l44.08-24.74c.18-.09.38-.11.57-.07l32.42,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.69.53,6.08-2.15,7.57,0,0,0,0-.01,0"
                                fill="#ced5ea"
                                stroke-width="0" />
                            <path
                                id="Path_965-2"
                                d="m118.93,194.54l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c-.01-3.09,2.48-5.61,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.58h-.01"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_966-2"
                                d="m118.93,194.54l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c-.01-3.09,2.48-5.61,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.57,0,0,0,0-.01,0Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                            <path
                                id="Path_967-2"
                                d="m123.49,117.04l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.61.4"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_968-2"
                                d="m123.49,117.04l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.62.4Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                        </g>
                    </g>
                </g>
            </g>
            <g
                id="Group_296-2-2"
                opacity=".56">
                <g id="Group_295-2-2">
                    <g clip-path="url(#clippath-1)">
                        <g id="Group_294-2-2">
                            <path
                                id="Path_964-2-2"
                                d="m418.4,163.31l-59.11,33.17c-2.7,1.51-6.11.55-7.62-2.14l-46.11-82.17c-1.51-2.7-.55-6.1,2.14-7.62l44.08-24.74c.18-.09.38-.11.57-.07l32.42,12.48c.14.07.26.18.33.32l35.46,63.19c1.5,2.69.53,6.08-2.15,7.57,0,0,0,0-.01,0"
                                fill="#ced5ea"
                                stroke-width="0" />
                            <path
                                id="Path_965-2-2"
                                d="m403.47,185.93l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c-.01-3.09,2.48-5.61,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.58h-.01"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_966-2-2"
                                d="m403.47,185.93l-67.78.28c-3.09,0-5.6-2.48-5.62-5.57l-.39-94.23c-.01-3.09,2.48-5.61,5.57-5.62l50.55-.21c.2,0,.39.08.53.22l22.28,26.66c.09.13.14.28.13.44l.3,72.46c0,3.08-2.49,5.57-5.56,5.57,0,0,0,0-.01,0Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                            <path
                                id="Path_967-2-2"
                                d="m408.03,108.44l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.61.4"
                                fill="#eff1fb"
                                stroke-width="0" />
                            <path
                                id="Path_968-2-2"
                                d="m408.03,108.44l-15.29.06c-4.14.02-7.55-3.8-7.57-8.52l-.08-18.86c0-.28.18-.52.44-.62.26-.08.55-.02.75.17l22.28,26.66c.18.19.22.47.09.7-.13.22-.36.37-.62.4Z"
                                fill="none"
                                stroke="#ced5ea"
                                stroke-miterlimit="10" />
                        </g>
                    </g>
                </g>
            </g>
            <path
                id="Path_2043-2"
                d="m151.67,171.05l-8.74,8.62h0s-.06.06-.09.1l-.04.04c-.21.25-.35.54-.41.86h0c-.01.06-.02.12-.03.19s-.01.13-.01.2c0,.07,0,.13.01.2,0,.06.02.12.03.19h0c.06.32.2.61.41.86.01.02.03.03.04.04.03.03.06.07.09.1h0l8.74,8.62c.77.76,2.01.75,2.77-.02.76-.77.75-2.01-.02-2.76h0l-5.35-5.28h14.35c1.08,0,1.96-.88,1.96-1.96s-.88-1.96-1.96-1.96h-14.35l5.35-5.28c.79-.74.82-1.98.08-2.76-.74-.79-1.98-.82-2.76-.08-.02.02-.05.05-.07.07"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2044-2"
                d="m177.36,181.07c0,1.08-.88,1.95-1.95,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96s.88-1.96,1.95-1.96h2.81c1.08,0,1.95.88,1.95,1.96"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2045-2"
                d="m294.18,191.08l8.74-8.62h0s.06-.06.09-.1l.04-.04c.21-.25.35-.54.41-.86h0c.01-.06.02-.12.03-.19s.01-.13.01-.2c0-.07,0-.13-.01-.2,0-.06-.02-.12-.03-.19h0c-.06-.32-.2-.61-.41-.86-.01-.02-.03-.03-.04-.04-.03-.03-.06-.07-.09-.1h0l-8.74-8.62c-.77-.76-2.01-.75-2.77.02-.76.77-.75,2.01.02,2.76h0l5.35,5.28h-14.35c-1.08,0-1.96.88-1.96,1.96s.88,1.96,1.96,1.96h14.35l-5.35,5.28c-.79.74-.82,1.98-.08,2.76.74.79,1.98.82,2.76.08.02-.02.05-.05.07-.07"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2046-2"
                d="m268.49,181.07c0-1.08.88-1.95,1.95-1.96h2.81c1.08,0,1.95.88,1.95,1.96s-.88,1.96-1.95,1.96h-2.81c-1.08,0-1.95-.88-1.95-1.96"
                fill="#555"
                stroke-width="0" />
            <g id="Group_671-2">
                <g id="Group_281-2">
                    <g clip-path="url(#clippath-2)">
                        <g id="Group_280-2">
                            <g id="Group_252-2">
                                <g id="Group_251-2">
                                    <g clip-path="url(#clippath-3)">
                                        <g id="Group_250-2">
                                            <path
                                                id="Path_901-2"
                                                d="m186.08,181.04v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#555"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_255-2">
                                <g id="Group_254-2">
                                    <g clip-path="url(#clippath-4)">
                                        <g id="Group_253-2">
                                            <path
                                                id="Path_902-2"
                                                d="m194.51,181.04v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#555"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_258-2">
                                <g id="Group_257-2">
                                    <g clip-path="url(#clippath-5)">
                                        <g id="Group_256-2">
                                            <path
                                                id="Path_903-2"
                                                d="m202.95,181.04v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#555"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_273-2">
                                <g id="Group_272-2">
                                    <g clip-path="url(#clippath-10)">
                                        <g id="Group_271-2">
                                            <path
                                                id="Path_908-2"
                                                d="m245.12,181.04v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#555"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_276-2">
                                <g id="Group_275-2">
                                    <g clip-path="url(#clippath-11)">
                                        <g id="Group_274-2">
                                            <path
                                                id="Path_909-2"
                                                d="m253.56,181.04v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#555"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                            <g id="Group_279-2">
                                <g id="Group_278-2">
                                    <g clip-path="url(#clippath-12)">
                                        <g id="Group_277-2">
                                            <path
                                                id="Path_910-2"
                                                d="m261.99,181.04v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93h0v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                                                fill="#555"
                                                stroke-width="0" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <path
                id="Path_1395"
                d="m151.62,97.06l-8.74,8.62h0s-.06.06-.09.1l-.04.04c-.21.25-.35.54-.41.86h0c-.01.06-.02.12-.03.19s-.01.13-.01.19c0,.07,0,.13.01.19,0,.06.02.12.03.19h0c.06.32.2.61.41.86.01.02.03.03.04.04.03.03.06.07.09.1h0l8.74,8.62c.77.76,2.01.75,2.76-.02s.75-2.01-.02-2.76h0l-5.35-5.28h14.35c1.08,0,1.96-.88,1.96-1.96s-.88-1.96-1.96-1.96h-14.35l5.35-5.28c.79-.74.82-1.98.08-2.76-.74-.79-1.98-.82-2.76-.08-.02.02-.05.04-.07.07"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1396"
                d="m177.3,106.63c0,1.08-.88,1.95-1.96,1.96h-2.81c-1.08,0-1.96-.88-1.96-1.96s.88-1.96,1.96-1.96h2.81c1.08,0,1.95.88,1.96,1.96"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1397"
                d="m186.32,106.6v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1398"
                d="m195.8,106.6v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1399"
                d="m205.7,106.6v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1400"
                d="m257.16,106.6v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1401"
                d="m247.08,106.6v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1419"
                d="m292.96,106.63c0-1.08.88-1.95,1.96-1.96h2.81c1.08,0,1.96.88,1.96,1.96s-.88,1.96-1.96,1.96h-2.81c-1.08,0-1.95-.88-1.96-1.96"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1420"
                d="m284.25,106.66v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1421"
                d="m273.97,106.66v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_1422"
                d="m263.41,106.66v-.06c0-1.06.86-1.93,1.93-1.93s1.93.86,1.93,1.93v.06c0,1.06-.86,1.93-1.93,1.93s-1.93-.86-1.93-1.93"
                fill="#44b649"
                stroke-width="0" />
            <path
                id="Path_2320"
                d="m228.18,178.1c.38-.17.74-.38,1.08-.62v1.55c0,.34-.25.78-.9,1.2.71-.04,1.42.06,2.09.3v-5.06c0-1.2-1.04-2.09-2.27-2.65-3.13-1.23-6.61-1.23-9.74,0-1.22.56-2.27,1.45-2.27,2.65v10.71c0,1.2,1.04,2.09,2.27,2.65,1.54.64,3.2.95,4.87.92.62,0,1.24-.04,1.85-.12-.37-.32-.7-.69-.97-1.1-.29.02-.58.03-.88.03-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.55c.34.25.7.46,1.08.62,1.54.64,3.2.95,4.87.92h.03c-.04-.4-.04-.79,0-1.19h-.03c-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.55c.34.25.7.46,1.08.62,1.54.64,3.2.95,4.87.92.31,0,.62,0,.92-.03.35-.52.8-.98,1.31-1.35-.74.13-1.48.19-2.23.19-1.5.03-2.99-.25-4.38-.82-1.14-.52-1.57-1.12-1.57-1.56v-1.55c.34.25.7.46,1.08.62,3.13,1.23,6.61,1.23,9.74,0m-10.82-2.65c0-.45.42-1.04,1.57-1.56,2.82-1.09,5.94-1.09,8.76,0,1.14.52,1.57,1.12,1.57,1.56s-.42,1.04-1.57,1.56c-2.82,1.09-5.94,1.09-8.76,0-1.14-.52-1.57-1.12-1.57-1.56"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2321"
                d="m232.28,184.83l-.18-.05c-.05,0-.1-.04-.15-.06-.37-.2-.5-.66-.3-1.03l.09-.16c.2-.37.06-.83-.31-1.03-.23-.12-.5-.12-.72,0l-.16.09s-.1.05-.15.06c-.4.12-.83-.11-.95-.52l-.05-.18c-.12-.4-.54-.63-.95-.52-.25.07-.44.27-.52.52l-.05.18c0,.05-.04.1-.06.15-.2.37-.66.51-1.03.31h0l-.16-.09c-.37-.2-.83-.06-1.03.31-.12.23-.12.5,0,.73l.09.16s.05.1.06.15c.12.4-.11.83-.51.94h0l-.18.05c-.4.12-.63.54-.52.95.07.25.27.44.52.52l.18.05c.05,0,.1.03.15.06.37.2.51.66.31,1.03h0l-.09.16c-.2.37-.06.83.31,1.03.23.12.5.12.73,0l.16-.09s.1-.05.15-.06c.4-.12.83.11.95.51l.05.18c.12.4.54.63.95.52.25-.07.44-.27.52-.52l.05-.18c.02-.05.04-.1.06-.15.2-.37.66-.51,1.03-.31h0l.16.09c.37.2.83.06,1.04-.31.12-.23.12-.5,0-.72l-.09-.16s-.05-.1-.06-.15c-.12-.4.11-.83.51-.94h0l.18-.05c.4-.12.63-.54.52-.95-.07-.25-.27-.44-.52-.52m-3.62,2.51c-.99,0-1.78-.8-1.78-1.78s.8-1.78,1.78-1.78,1.78.8,1.78,1.78-.8,1.78-1.78,1.78"
                fill="#555"
                stroke-width="0" />
            <text
                transform="translate(208.81 197.46)"
                fill="#555"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="6"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Sends Data
                </tspan>
            </text>
            <text
                transform="translate(67.64 146.73)"
                fill="#405184"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Project
                </tspan>
                <tspan
                    x="-6.96"
                    y="12">
                    Table Row
                </tspan>
            </text>
            <text
                transform="translate(341.99 146.73)"
                fill="#405184"
                font-family="SourceSansPro-Semibold, 'Source Sans Pro'"
                font-size="10"
                font-weight="600">
                <tspan
                    x="0"
                    y="0">
                    Project Table
                </tspan>
            </text>
            <path
                id="Path_1118-2"
                d="m73.51,132.64h-3.67c-.65,0-1.18-.53-1.19-1.18h0v-1.42c0-.65.53-1.18,1.18-1.18h3.67c.65,0,1.18.53,1.18,1.18h0v1.42c0,.65-.53,1.18-1.18,1.18h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1119-2"
                d="m84.99,132.64h-3.67c-.65,0-1.19-.53-1.19-1.18h0v-1.42c0-.65.53-1.18,1.18-1.18h3.67c.65,0,1.18.53,1.19,1.18h0v1.42c0,.65-.53,1.18-1.19,1.18h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1120-2"
                d="m96.48,132.64h-3.67c-.65,0-1.19-.53-1.19-1.18h0v-1.42c0-.65.53-1.18,1.18-1.18h3.67c.65,0,1.18.53,1.18,1.18h0v1.42c0,.65-.53,1.18-1.18,1.18h0"
                fill="#405184"
                stroke-width="0" />
            <line
                id="Line_87"
                x1="355.86"
                y1="110.75"
                x2="360.41"
                y2="110.75"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_88"
                x1="368.84"
                y1="110.75"
                x2="373.01"
                y2="110.75"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_89"
                x1="381.92"
                y1="110.75"
                x2="386.08"
                y2="110.75"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_90"
                x1="355.81"
                y1="129.28"
                x2="360.37"
                y2="129.28"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_91"
                x1="368.79"
                y1="129.28"
                x2="372.96"
                y2="129.28"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_92"
                x1="381.87"
                y1="129.28"
                x2="386.03"
                y2="129.28"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_93"
                x1="355.86"
                y1="116.99"
                x2="360.41"
                y2="116.99"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_94"
                x1="368.84"
                y1="116.99"
                x2="373.01"
                y2="116.99"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_95"
                x1="381.92"
                y1="116.99"
                x2="386.08"
                y2="116.99"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_96"
                x1="355.81"
                y1="123.04"
                x2="360.37"
                y2="123.04"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_97"
                x1="368.79"
                y1="123.04"
                x2="372.96"
                y2="123.04"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <line
                id="Line_98"
                x1="381.87"
                y1="123.04"
                x2="386.03"
                y2="123.04"
                fill="none"
                stroke="#405184"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="2" />
            <text
                transform="translate(186.32 119.79)"
                fill="#555"
                font-family="SourceSansPro-SemiBold, 'Source Sans Pro'"
                font-size="8"
                font-weight="600"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Creates New Project Via
                </tspan>
                <tspan
                    x="17.57"
                    y="9.6">
                    Project Table
                </tspan>
            </text>
            <path
                id="Path_2065"
                d="m223.8,106.78c-.13,0-.24-.09-.28-.21l-3.91-14.72c-.02-.15.06-.29.2-.35l7.68-2.04,4.21,3.01,2.96,11.15c.04.15-.06.3-.21.34l-10.59,2.81h-.07Z"
                fill="#eff1fb"
                stroke-width="0" />
            <path
                id="Path_2066"
                d="m227.37,90.13l3.8,2.71,2.81,10.6-9.95,2.64-3.73-14.08,7.07-1.87Zm.22-1.33h-.03l-7.9,2.1c-.48.13-.77.62-.64,1.1,0,0,0,0,0,0l3.9,14.72c.11.4.47.67.88.67.08,0,.16-.01.23-.03l10.59-2.81c.48-.12.77-.62.65-1.1,0,0,0,0,0,0l-3-11.32s-.02-.05-.04-.06l-4.57-3.26s-.04-.02-.06-.02"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2067"
                d="m231.53,106.89l-10.62-2.69c-.14-.05-.23-.2-.21-.35l3.73-14.76c.03-.13.15-.21.28-.21l7.77,1.96,2.22,4.68-2.83,11.18c-.03.12-.14.21-.27.21-.02,0-.05,0-.07,0"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2068"
                d="m224.95,89.57l7.09,1.8,2,4.21-2.69,10.63-9.97-2.52,3.58-14.12Zm-.24-1.31c-.41,0-.78.28-.88.68l-3.74,14.76c-.12.48.17.98.66,1.1l10.62,2.69c.07.02.15.03.22.03.41,0,.77-.28.87-.68l2.87-11.35s0-.05,0-.07l-2.41-5.07s-.04-.05-.07-.06l-7.92-2c-.07-.02-.15-.03-.22-.03"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2069"
                d="m232.97,94.34c-.35-.14-.52-.53-.39-.89l.4-1.59,1.34,2.82-1.34-.34Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2070"
                d="m233.16,93.71l.04.07h-.02s-.02-.05-.02-.07m-.34-3.44h0s-.08.03-.09.08l-.75,2.96c-.21.68.16,1.41.84,1.64l2.4.61h.02s.07-.02.09-.04c.03-.03.03-.08.01-.11l-2.41-5.07s-.06-.06-.1-.06"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2071"
                d="m221.84,108.48c-3.4,0-6.15-2.75-6.15-6.15,0-3.4,2.75-6.15,6.15-6.15s6.15,2.75,6.15,6.15h0c0,3.4-2.76,6.15-6.15,6.15"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2072"
                d="m221.84,96.79c3.06,0,5.54,2.48,5.53,5.54,0,3.06-2.48,5.53-5.54,5.53-3.06,0-5.53-2.48-5.53-5.54,0-3.06,2.48-5.53,5.54-5.54m0-1.24c-3.74,0-6.77,3.03-6.77,6.77,0,3.74,3.03,6.77,6.77,6.77,3.74,0,6.77-3.03,6.77-6.77,0-3.74-3.03-6.77-6.77-6.77"
                fill="#555"
                stroke-width="0" />
            <line
                id="Line_76"
                x1="221.91"
                y1="99.41"
                x2="221.91"
                y2="105.24"
                fill="none"
                stroke="#555"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <line
                id="Line_78"
                x1="224.76"
                y1="102.11"
                x2="218.93"
                y2="102.11"
                fill="none"
                stroke="#555"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <path
                id="Path_2065-2"
                d="m223.8,106.78c-.13,0-.24-.09-.28-.21l-3.91-14.72c-.02-.15.06-.29.2-.35l7.68-2.04,4.21,3.01,2.96,11.15c.04.15-.06.3-.21.34l-10.59,2.81h-.07Z"
                fill="#eff1fb"
                stroke-width="0" />
            <path
                id="Path_2066-2"
                d="m227.37,90.13l3.8,2.71,2.81,10.6-9.95,2.64-3.73-14.08,7.07-1.87Zm.22-1.33h-.03l-7.9,2.1c-.48.13-.77.62-.64,1.1,0,0,0,0,0,0l3.9,14.72c.11.4.47.67.88.67.08,0,.16-.01.23-.03l10.59-2.81c.48-.12.77-.62.65-1.1,0,0,0,0,0,0l-3-11.32s-.02-.05-.04-.06l-4.57-3.26s-.04-.02-.06-.02"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2067-2"
                d="m231.53,106.89l-10.62-2.69c-.14-.05-.23-.2-.21-.35l3.73-14.76c.03-.13.15-.21.28-.21l7.77,1.96,2.22,4.68-2.83,11.18c-.03.12-.14.21-.27.21-.02,0-.05,0-.07,0"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2068-2"
                d="m224.95,89.57l7.09,1.8,2,4.21-2.69,10.63-9.97-2.52,3.58-14.12Zm-.24-1.31c-.41,0-.78.28-.88.68l-3.74,14.76c-.12.48.17.98.66,1.1l10.62,2.69c.07.02.15.03.22.03.41,0,.77-.28.87-.68l2.87-11.35s0-.05,0-.07l-2.41-5.07s-.04-.05-.07-.06l-7.92-2c-.07-.02-.15-.03-.22-.03"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2069-2"
                d="m232.97,94.34c-.35-.14-.52-.53-.39-.89l.4-1.59,1.34,2.82-1.34-.34Z"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2070-2"
                d="m233.16,93.71l.04.07h-.02s-.02-.05-.02-.07m-.34-3.44h0s-.08.03-.09.08l-.75,2.96c-.21.68.16,1.41.84,1.64l2.4.61h.02s.07-.02.09-.04c.03-.03.03-.08.01-.11l-2.41-5.07s-.06-.06-.1-.06"
                fill="#555"
                stroke-width="0" />
            <path
                id="Path_2071-2"
                d="m221.84,108.48c-3.4,0-6.15-2.75-6.15-6.15,0-3.4,2.75-6.15,6.15-6.15s6.15,2.75,6.15,6.15h0c0,3.4-2.76,6.15-6.15,6.15"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2072-2"
                d="m221.84,96.79c3.06,0,5.54,2.48,5.53,5.54,0,3.06-2.48,5.53-5.54,5.53-3.06,0-5.53-2.48-5.53-5.54,0-3.06,2.48-5.53,5.54-5.54m0-1.24c-3.74,0-6.77,3.03-6.77,6.77,0,3.74,3.03,6.77,6.77,6.77,3.74,0,6.77-3.03,6.77-6.77,0-3.74-3.03-6.77-6.77-6.77"
                fill="#555"
                stroke-width="0" />
            <line
                id="Line_76-2"
                x1="221.91"
                y1="99.41"
                x2="221.91"
                y2="105.24"
                fill="none"
                stroke="#555"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <line
                id="Line_78-2"
                x1="224.76"
                y1="102.11"
                x2="218.93"
                y2="102.11"
                fill="none"
                stroke="#555"
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width=".75" />
            <path
                id="Rectangle_110"
                d="m317.79,167.22h98.78c4.31,0,7.81,3.21,7.81,7.17v15.26c0,3.96-3.5,7.17-7.81,7.17h-98.78c-4.31,0-7.81-3.21-7.81-7.17v-15.26c0-3.96,3.5-7.17,7.81-7.17Z"
                fill="#f0f1f9"
                isolation="isolate"
                opacity=".8"
                stroke="#405184"
                stroke-miterlimit="10"
                stroke-width=".25" />
            <path
                id="Path_2284"
                d="m327.5,176.06c-.11,0-.21-.04-.29-.12-2.31-2.3-6.04-2.3-8.35,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,2.63-2.62,6.89-2.62,9.52,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2285"
                d="m319.73,177.23c-.11,0-.21-.04-.29-.12-.16-.16-.16-.42,0-.58,1.99-1.98,5.2-1.98,7.19,0,.16.16.17.42,0,.58-.16.16-.42.17-.58,0h0c-1.66-1.66-4.36-1.66-6.02,0-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2286"
                d="m325.17,178.39c-.11,0-.21-.04-.29-.12-1.03-.99-2.66-.99-3.69,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,1.36-1.3,3.5-1.3,4.86,0,.16.16.16.42,0,.58h0c-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2287"
                d="m324.34,188.34h-2.99c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h2.99c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2288"
                d="m322.85,188.2c-.18,0-.33-.15-.33-.33v-.92c0-.18.15-.33.33-.33s.33.15.33.33v.92c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2289"
                d="m322.54,183.43c-.11,0-.21-.05-.27-.14l-1.07-1.56c-.1-.15-.06-.36.09-.46s.36-.06.46.09l1.07,1.56c.1.15.07.35-.08.46h0c-.06.04-.12.06-.19.06"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2290"
                d="m324.63,184.48s-.07,0-.11-.02l-1.49-.51c-.17-.06-.26-.25-.2-.42s.24-.26.41-.2h0l1.49.51c.17.06.26.25.2.42-.05.13-.17.22-.31.22"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2291"
                d="m320.66,180.93c-.09,0-.17-.04-.23-.1l-.99-.99c-.13-.13-.13-.34,0-.47s.34-.13.47,0h0l.99.99c.13.13.13.34,0,.47-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2292"
                d="m324.88,180.93c-.18,0-.33-.15-.33-.33,0-.09.03-.17.1-.23l1.05-1.05c.13-.13.34-.13.47,0s.13.34,0,.47l-1.05,1.05c-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2293"
                d="m322.81,187.17c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2294"
                d="m322.81,184.15c-.41,0-.74-.33-.74-.74s.33-.74.74-.74.74.33.74.74-.33.74-.74.74m0-.82s-.08.04-.08.08c0,.09.16.09.16,0,0-.04-.03-.08-.08-.08h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2295"
                d="m322.81,187.17c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2296"
                d="m322.81,181.36c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2297"
                d="m322.81,186.51c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2298"
                d="m325.59,183.72h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2299"
                d="m320.45,183.72h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <text
                transform="translate(334.97 184.87)"
                fill="#405184"
                font-family="SourceSansPro-BoldItalic, 'Source Sans Pro'"
                font-size="8"
                font-style="italic"
                font-weight="700"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Automation Signal
                </tspan>
            </text>
            <path
                id="Rectangle_110-2"
                d="m31.33,167.22h98.78c4.31,0,7.81,3.21,7.81,7.17v15.26c0,3.96-3.5,7.17-7.81,7.17H31.33c-4.31,0-7.81-3.21-7.81-7.17v-15.26c0-3.96,3.5-7.17,7.81-7.17Z"
                fill="#f0f1f9"
                isolation="isolate"
                opacity=".8"
                stroke="#405184"
                stroke-miterlimit="10"
                stroke-width=".25" />
            <path
                id="Path_2284-2"
                d="m41.04,176.06c-.11,0-.21-.04-.29-.12-2.31-2.3-6.04-2.3-8.35,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,2.63-2.62,6.89-2.62,9.52,0,.16.16.16.42,0,.58-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2285-2"
                d="m33.27,177.23c-.11,0-.21-.04-.29-.12-.16-.16-.16-.42,0-.58,1.99-1.98,5.2-1.98,7.19,0,.16.16.17.42,0,.58-.16.16-.42.17-.58,0h0c-1.66-1.66-4.36-1.66-6.02,0-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2286-2"
                d="m38.71,178.39c-.11,0-.21-.04-.29-.12-1.03-.99-2.66-.99-3.69,0-.16.16-.43.15-.58,0-.16-.16-.16-.41,0-.57,1.36-1.3,3.5-1.3,4.86,0,.16.16.16.42,0,.58h0c-.08.08-.18.12-.29.12"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2287-2"
                d="m37.88,188.34h-2.99c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h2.99c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2288-2"
                d="m36.39,188.2c-.18,0-.33-.15-.33-.33v-.92c0-.18.15-.33.33-.33s.33.15.33.33v.92c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2289-2"
                d="m36.08,183.43c-.11,0-.21-.05-.27-.14l-1.07-1.56c-.1-.15-.06-.36.09-.46s.36-.06.46.09l1.07,1.56c.1.15.07.35-.08.46h0c-.06.04-.12.06-.19.06"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2290-2"
                d="m38.17,184.48s-.07,0-.11-.02l-1.49-.51c-.17-.06-.26-.25-.2-.42s.24-.26.41-.2h0l1.49.51c.17.06.26.25.2.42-.05.13-.17.22-.31.22"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2291-2"
                d="m34.2,180.93c-.09,0-.17-.04-.23-.1l-.99-.99c-.13-.13-.13-.34,0-.47s.34-.13.47,0h0l.99.99c.13.13.13.34,0,.47-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2292-2"
                d="m38.42,180.93c-.18,0-.33-.15-.33-.33,0-.09.03-.17.1-.23l1.05-1.05c.13-.13.34-.13.47,0s.13.34,0,.47l-1.05,1.05c-.06.06-.15.1-.23.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2293-2"
                d="m36.35,187.17c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2294-2"
                d="m36.35,184.15c-.41,0-.74-.33-.74-.74s.33-.74.74-.74.74.33.74.74-.33.74-.74.74m0-.82s-.08.04-.08.08c0,.09.16.09.16,0,0-.04-.03-.08-.08-.08h0"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2295-2"
                d="m36.35,187.17c-2.08,0-3.76-1.68-3.76-3.76s1.68-3.76,3.76-3.76,3.76,1.68,3.76,3.76-1.68,3.76-3.76,3.76m0-6.86c-1.71,0-3.1,1.39-3.1,3.1s1.39,3.1,3.1,3.1,3.1-1.39,3.1-3.1h0c0-1.71-1.39-3.1-3.1-3.1"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2296-2"
                d="m36.35,181.36c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2297-2"
                d="m36.35,186.51c-.18,0-.33-.15-.33-.33v-.43c0-.18.15-.33.33-.33s.33.15.33.33v.43c0,.18-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2298-2"
                d="m39.13,183.72h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_2299-2"
                d="m33.99,183.72h-.43c-.18,0-.33-.15-.33-.33s.15-.33.33-.33h.43c.18,0,.33.15.33.33s-.15.33-.33.33"
                fill="#405184"
                stroke-width="0" />
            <text
                transform="translate(48.51 184.87)"
                fill="#405184"
                font-family="SourceSansPro-BoldItalic, 'Source Sans Pro'"
                font-size="8"
                font-style="italic"
                font-weight="700"
                letter-spacing="-.01em">
                <tspan
                    x="0"
                    y="0">
                    Automation Signal
                </tspan>
            </text>
            <path
                id="Path_1563-2"
                d="m73.84,20.9c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                fill="#5c73b8"
                stroke-width="0" />
            <g id="Group_715">
                <path
                    id="Path_2499"
                    d="m77.85.54c9.43,0,17.08,7.65,17.08,17.08s-7.65,17.08-17.08,17.08-17.08-7.65-17.08-17.08h0c0-9.43,7.64-17.08,17.08-17.08h0"
                    fill="#fff"
                    stroke="#405184"
                    stroke-miterlimit="10" />
                <path
                    id="Path_2512"
                    d="m75.37,23.63l-2.94,3.36c-.23.29-.18.71.1.94.27.22.66.19.9-.06l2.94-3.36c.23-.28.19-.7-.09-.94-.27-.22-.67-.2-.91.06"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2509"
                    d="m67.92,22.69c.17,0,.34-.07.47-.19l3.22-3.11c.27-.25.28-.67.03-.94s-.67-.28-.94-.03c0,0-.01.01-.02.02l-3.22,3.11c-.27.25-.29.66-.04.93.13.14.31.22.51.21"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2510"
                    d="m74.86,20.22c-.25-.26-.67-.27-.93-.01h0l-6.58,6.54c-.27.25-.28.66-.03.93.13.14.31.22.5.21.18,0,.35-.07.47-.2l6.58-6.52c.26-.25.27-.67.01-.93h-.01"
                    fill="#405184"
                    stroke-width="0" />
                <path
                    id="Path_2505"
                    d="m88.52,8.21v-.11s-.01-.07-.02-.1c-.01-.04-.03-.07-.05-.11,0-.02-.01-.04-.02-.06l-.03-.03s-.05-.06-.08-.08c-.03-.03-.05-.05-.08-.07l-.03-.03s-.04-.01-.06-.02c-.03-.02-.07-.03-.11-.04-.03-.01-.07-.02-.11-.02h-.11s-.07,0-.11.01c-.02,0-.05,0-.07.01l-20.07,6.73c-.35.1-.55.47-.45.82.06.21.22.37.42.44l9.48,3.63,3.78,9.43c.1.25.35.42.62.42h.02c.28,0,.53-.19.61-.46l6.41-20.17s0-.05.01-.07c0-.04.01-.07.01-.11m-3.09,1.49l-8.04,8.17-7.61-2.91s15.65-5.26,15.65-5.26Zm-4.07,16.66l-3.02-7.55,8.04-8.17s-5.02,15.72-5.02,15.72Z"
                    fill="#405184"
                    stroke-width="0" />
            </g>
            <polygon
                points="81.3 26.37 78.29 18.8 86.36 10.66 81.3 26.37"
                fill="#fff"
                stroke-width="0" />
            <polygon
                points="85.39 9.71 77.35 17.88 69.74 14.97 85.39 9.71"
                fill="#fff"
                stroke-width="0" />
            <path
                id="Path_2252"
                d="m353.79,22.08v7.7h7.19l-.51-7.18s-6.68-.52-6.68-.52Z"
                fill="#cfd5ea"
                stroke-width="0" />
            <path
                id="Path_2257"
                d="m369.65,17.3c.28,0,.51.23.51.51v8.53c0,.28-.23.51-.51.51h-8.49c-.28,0-.51-.23-.51-.51s.23-.51.51-.51h7.98v-8.02c0-.28.23-.51.51-.51"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_2258"
                d="m360.97,29.78h-7.19c-.28,0-.51-.23-.51-.51h0v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.68-1.02h6.16v-6.16h-6.16v6.16Z"
                fill="#5c73b8"
                stroke-width="0" />
            <path
                id="Path_1485"
                d="m363.64.82c9.41,0,17.03,7.63,17.03,17.03s-7.63,17.03-17.03,17.03-17.03-7.63-17.03-17.03h0c0-9.41,7.63-17.03,17.03-17.03"
                fill="#fff"
                stroke="#405184" />
            <rect
                id="Rectangle_308"
                x="366.11"
                y="8.23"
                width="7.19"
                height="7.19"
                fill="#95b1e8"
                stroke-width="0" />
            <rect
                id="Rectangle_309"
                x="353.47"
                y="20.1"
                width="7.19"
                height="7.19"
                fill="#95b1e8"
                stroke-width="0" />
            <path
                id="Path_1487"
                d="m373.29,15.93h-7.19c-.28,0-.51-.23-.51-.51v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.68-1.02h6.17v-6.16h-6.17v6.16Z"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1488"
                d="m357.57,20.87c-.28,0-.51-.23-.51-.51v-8.53c0-.28.23-.51.51-.51h8.49c.28,0,.51.23.51.51s-.23.51-.51.51h-7.98v8.02c0,.28-.23.51-.51.51"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1489"
                d="m369.84,15.58c.28,0,.51.23.51.51v8.53c0,.28-.23.51-.51.51h-8.49c-.28,0-.51-.23-.51-.51s.23-.51.51-.51h7.98v-8.02c0-.28.23-.51.51-.51"
                fill="#405184"
                stroke-width="0" />
            <path
                id="Path_1490"
                d="m361.17,28.06h-7.19c-.28,0-.51-.23-.51-.51v-7.19c0-.28.23-.51.51-.51h7.19c.28,0,.51.23.51.51v7.19c0,.28-.23.51-.51.51m-6.67-1.02h6.16v-6.16h-6.16v6.16Z"
                fill="#405184"
                stroke-width="0" />
            <rect
                id="Rectangle_310-2"
                x="345.78"
                width="35.71"
                height="35.71"
                fill="none"
                stroke-width="0" />
        </g>
    </svg>
</template>
